import DCParameterService from '@/services/dcparameter.service'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
}

const getters = {}

const actions = {
    read: async ({ commit, state }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (!args.limit) args.limit = 10
        if (state.page.index == args.page) return true
        try {
            let page = await DCParameterService.read(args)
            commit('readSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    update: async ({ commit }, entity) => {
        if (!entity) return

        try {
            await DCParameterService.update(entity)

            commit('updateSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    remove: async ({ commit }, args) => {
        if (!args.dc_ids || !args.simulation) return

        try {
            await DCParameterService.deleteByDCIds(args.simulation, args.dc_ids)
            commit('removeSuccess', args.dc_ids)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    readSuccess(state, page, page_index) {
        state.page = page
        state.page.index = page_index
    },
    updateSuccess(state) {

    },

    removeSuccess(state, dc_ids) {
        state.page.results
            .filter(a => dc_ids.filter(b => a.branch == b).length > 0)
            .forEach(a => (a.status = 'M'))
    }
}

const dcparameter = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default dcparameter
export { dcparameter }
